<mat-form-field
  *transloco="let t; read: 'text-input'"
  [floatLabel]="'always'"
  [class.hide-label]="!label()">
  <!-- NB: adding *ngIf to hide mat-label will lead to placeholders being promoted to a label when a label isn't present -->
  <mat-label>
    <span>
      {{ label() }}
      @if (requirementLabel()) {
        <span class="requirementLabel">
          {{ t(requirementLabel()) }}
        </span>
      }
    </span>
    @if (!!hint()) {
      <mat-icon class="hint-icon icon-info" [matTooltip]="hint()" />
    }
  </mat-label>

  @if (!!icon() && type() !== 'textarea') {
    <mat-icon [ngClass]="icon()" class="icon" />
  }

  @if (searchable() && type() !== 'textarea') {
    <mat-icon class="clickable-icon search-icon icon-search" />
  }

  @if (type() === 'textarea') {
    <textarea
      #textareaInput
      matInput
      [style.minHeight]="textAreaMinHeight() + 'px'"
      [placeholder]="placeholder()"
      [readOnly]="readonly()"
      [formControl]="formControlRef()"
      [cdkTextareaAutosize]="true"
      [required]="required()"
      [attr.maxLength]="maxLength() || null"
      [attr.aria-label]="ariaLabel()"
      [attr.data-cy]="dataCy() || null"
      (blur)="onBlur($event)">
    </textarea>
  } @else {
    <input
      #textInput
      matInput
      [class.has-icon]="!!icon()"
      [class.searchable]="searchable()"
      [placeholder]="placeholder()"
      [readonly]="readonly()"
      [type]="inputType()"
      [autocomplete]="autoComplete()"
      [formControl]="formControlRef()"
      [required]="required()"
      [attr.maxLength]="type() !== 'number' ? maxLength() || null : null"
      [attr.aria-label]="ariaLabel()"
      [attr.data-cy]="dataCy() || null"
      (blur)="onBlur($event)" />

    @if (type() === 'password') {
      <mat-icon
        [attr.data-cy]="dataCy() ? dataCy() + '-input-toggle-visibility' : null"
        [class]="
          'clickable-icon icon-visibility-toggle icon-' + (isPasswordVisible() ? 'hide' : 'view')
        "
        [class.error]="formControlRef().touched && formControlRef().invalid"
        (click)="togglePasswordVisibility($event)" />
    }
  }

  @if (legacyHint()) {
    <mat-hint>{{ legacyHint() }}</mat-hint>
  }

  @if (!noError()) {
    <mat-error>
      <accredible-input-error>
        <ng-content />
      </accredible-input-error>
    </mat-error>
  }
</mat-form-field>
